export const ELEMENT_IDS = {
  header: 'globalHeader',
  footer: 'footer',
};
